module.exports = __webpack_public_path__ + "assets/img/6_634_big.a0c72a33.jpg";